export const transactionRequestDirection = {
  In: () => 'TRANSACTION_REQUEST_DIRECTION_IN',
  Out: () => 'TRANSACTION_REQUEST_DIRECTION_OUT',
  Invalid: () => 'TRANSACTION_REQUEST_DIRECTION_INVALID',
}
